import {Collapse} from '@mui/material';

import {JobMatchSection} from './JobMatchSection';
import {MatchData} from '../../../../../../../types/shared-recruiting-types';

interface Props {
  open: boolean;
  data?: MatchData;
}

export const CollapsedMatchInformation = ({open, data}: Props) => {
  return (
    <Collapse in={open} orientation='vertical' sx={{width: '100%'}}>
      <JobMatchSection jobMatchData={data?.jobMatchInformation} />
    </Collapse>
  );
};
